import React, { FunctionComponent, useEffect } from "react";
import styles from "../css/Section5.module.css";
import { useSelector } from "react-redux";
import TelegramIcon from "@mui/icons-material/Telegram";
import InstagramIcon from "@mui/icons-material/Instagram";
import { Link, useLocation } from "react-router-dom";
import marianaMain1 from "../../assets/mariana_pics/main1.png";

const Section5 = () => {
  const language = useSelector((state: any) => state.language.value);

  return (
    <div className={styles.frag} style={{ backgroundColor: "#F9F6E9" }}>
      <div className={styles.mainContainer}>
        <div className={styles.elementLeft}>
          <div className={styles.bookPhoto}>
            <img src={marianaMain1} alt="book" className={styles.bookImage} />
          </div>
        </div>
        <div className={styles.elementRight}>
          <div className={styles.title}>
            <span className={styles.authorInfo}>
              {" "}
              {language === "EN" && "About the author"}
              {language === "RO" && "Despre autoare"}
            </span>
            <div className={styles.authorInfo1} style={{ color: "#517059" }}>
              {language === "EN" && "About the author"}
              {language === "RO" && "Despre autoare"}
            </div>
          </div>
          <div className={styles.bookPhoto4}>
            <div className={styles.bookImage5} />
          </div>
        </div>

        <div className={styles.text}>
          <span className={styles.personalStory}>
            {language === "RO" && (
              <>
                <span>
                  Sunt <span style={{ color: "#C4B57C" }}>Mariana Melnic</span>{" "}
                  – o visătoare care a transformat durerea în putere,
                  vulnerabilitatea în curaj și dorința de a mă ascunde în
                  bucuria de a mă arăta lumii așa cum sunt. Mi-am scris povestea
                  inspirată de curajul de a fi liberă și de dorința de a arăta
                  că sufletul nu trebuie să fie întemnițat de frici sau
                  așteptări. <strong>Eu am ales să fiu un spirit liber.</strong>
                </span>{" "}
              </>
            )}
            {language === "EN" && (
              <>
                <span>
                  I am <span style={{ color: "#C4B57C" }}>Mariana Melnic</span>{" "}
                  – a dreamer who has transformed pain into strength,
                  vulnerability into courage, and the desire to remain hidden
                  into the empowering joy of revealing myself to the world as I
                  truly am. My story was born from the courage to embrace
                  freedom and the conviction that the soul should never be bound
                  by fear or external expectations.{" "}
                  <strong>I have chosen to live as a free spirit.</strong>
                </span>{" "}
              </>
            )}{" "}
          </span>
          {/* <span className={styles.personalStory}>
            {language === "EN" && (
              <>
                <span>
                  My journey is unique, as is each individual's path. You, too,
                  have your own journey and your own lessons to learn. And
                  perhaps, this moment marks the beginning of your own
                  transformative journey.
                </span>{" "}
              </>
            )}
            {language === "RO" && (
              <>
                <span>
                  Drumul meu este unic, la fel ca drumul fiecăruia dintre noi.
                  Tu ai propriul drum, propriile lecții. Și poate că acest
                  moment este începutul călătoriei tale.
                </span>{" "}
              </>
            )}{" "}
          </span> */}
          <span className={styles.motivationInspiration}>
            {language === "RO" && (
              <>
                <span>
                  Te invit să-ți descoperi propria libertate interioară, pagină
                  cu pagină, împreună cu SPIRIT LIBER.{" "}
                </span>{" "}
              </>
            )}
            {language === "EN" && (
              <>
                <span>
                  I invite you to explore your inner freedom, page by page,
                  alongside FREE SPIRIT.
                </span>{" "}
              </>
            )}{" "}
          </span>
          <div className={styles.InviteContainer}>
            <Link to="/about" className={styles.someButton}>
              {language === "RO" && "Te invit aici"}
              {language === "EN" && "I invite you here"}
            </Link>
            <div style={{ display: "flex", gap: "10px" }}>
              <a
                href="https://www.instagram.com/mariana.melnic13/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <InstagramIcon style={{ fill: "#C4B57C", cursor: "pointer" }} />
              </a>{" "}
              <TelegramIcon style={{ fill: "#C4B57C" }} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Section5;
